import { render, staticRenderFns } from "./testcope.vue?vue&type=template&id=51a20fed&scoped=true"
import script from "./testcope.vue?vue&type=script&lang=js"
export * from "./testcope.vue?vue&type=script&lang=js"
import style0 from "./testcope.vue?vue&type=style&index=0&id=51a20fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a20fed",
  null
  
)

export default component.exports